<template>
  <v-container class="fluid-max-width pa-0">
    <v-breadcrumbs :items="breadcrumbItems">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    <v-expansion-panels flat tile class="shafts-list" v-model="expandedSite">
      <v-expansion-panel v-for="item in sites" :key="item.id" class="mb-1">
        <v-expansion-panel-header class="grey lighten-3">
          <div>
            <p class="pa-0 ma-0 mb-1">
              <span class="v-list-item__title font-weight-bold"
                >{{ item.name }}
              </span>
            </p>
            <p class="pa-0 ma-0">
              <span class="subtitle">{{ item.street }}</span>
              <span class="subtitle" v-if="item.street">, </span>
              <span class="subtitle"
                >{{ item.postal_code }} {{ item.city }}</span
              >
            </p>
          </div>

          <div class="order-button">
            <v-btn
              depressed
              outlined
              color="primary"
              class="d-none d-sm-block"
              :loading="isOrdering"
              @click.prevent.stop="onOrderShaftsClicked(item)"
              v-if="orderButtonVisible(item)"
            >
              <v-icon>mdi-cart-arrow-down</v-icon>
              <span class="ml-2">Sammelbestellung</span>
            </v-btn>
            <v-btn
              fab
              depressed
              x-small
              outlined
              color="primary"
              class="d-sm-none"
              :loading="isOrdering"
              @click.prevent.stop="onOrderShaftsClicked(item)"
              v-if="orderButtonVisible(item)"
            >
              <v-icon>mdi-cart-arrow-down</v-icon>
            </v-btn>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <ShaftList :shafts="item.shafts" :site="item" showAdd="true" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-list-item class="add-item grey lighten-3" to="/baustelle/neu">
      <v-list-item-content>
        <v-list-item-title class="text-center">
          <v-icon large color="primary" class="mr-2">mdi-plus-circle</v-icon>
          <span>Baustelle hinzufügen</span>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <DialogOrderInput
      :dialogVisible="orderDialogVisible"
      :site="orderDialogSite"
      @orderClick="onOrderClicked"
    />
    <DialogOrderConfirm
      ref="orderDialog"
      caption="Schächte verbindlich"
      title="bestellen?"
      message="Ihre Auswahl an Schachtkonfigurationen ist vollständig und wird zur Auftragserfassung weitergegeben."
      ok="Ja, bestellen"
      cancel="Abbrechen"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ShaftList from '@/components/ShaftList.vue';
import DialogOrderInput from '@/components/DialogOrderInput.vue';
import DialogOrderConfirm from '@/components/DialogOrderConfirm.vue';

export default {
  name: 'Sites',
  components: { ShaftList, DialogOrderInput, DialogOrderConfirm },
  data: () => ({
    expandedSite: -1,
    orderDialogVisible: false,
    orderDialogSite: undefined,
    isOrdering: false,
    breadcrumbItems: [
      {
        text: 'Home',
        disabled: false,
        to: '/',
      },
      {
        text: 'Baustellen',
        disabled: true,
        to: '/baustellen',
      },
    ],
  }),
  computed: {
    ...mapGetters(['isLoggedIn', 'user', 'sites', 'selectedSite', 'isBack']),
  },
  watch: {
    expandedSite() {
      this.setSelectedSite(this.expandedSite);
    },
  },
  async created() {
    await this.autoLogin();
    if (!this.sites) await this.getSites();
    if (!this.isBack && this.$route.params.id) {
      var index = this.sites.findIndex(
        site => site.id === parseInt(this.$route.params.id),
      );
      this.setSelectedSite(index);
    } else if (!this.isBack) {
      this.setSelectedSite(-1);
    }
    setTimeout(() => {
      this.expandedSite = this.selectedSite;
    }, 500);
  },
  methods: {
    ...mapActions([
      'autoLogin',
      'getSites',
      'getUser',
      'setSelectedSite',
      'orderShafts',
    ]),
    onOrderShaftsClicked(item) {
      this.orderDialogSite = item;
      this.orderDialogVisible = false;
      this.$nextTick(() => {
        this.orderDialogVisible = true;
      });
    },
    async onOrderClicked(items) {
      var result = await this.$refs.orderDialog.show();
      if (result) {
        this.isOrdering = true;
        await this.orderShafts({ shafts: items, deliveryDate: result });
        this.isOrdering = false;
      }
    },
    orderButtonVisible(item) {
      if (!item.shafts) return;
      var orderable = false;
      item.shafts.forEach(shaft => {
        if (!shaft.ordered) orderable = true;
      });
      return item.shafts.length > 0 && orderable;
    },
  },
};
</script>

<style scoped>
.add-item {
  height: 64px;
}

.subtitle {
  color: rgba(0, 0, 0, 0.6);
}

.shafts-list >>> .v-expansion-panel-content__wrap {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

.v-expansion-panel-header--active >>> .v-expansion-panel-header__icon {
  display: none;
}

.order-button {
  position: absolute;
  right: 20px;
}

.v-expansion-panel-header >>> .order-button {
  display: none;
}

.v-expansion-panel-header--active >>> .order-button {
  display: block;
}
</style>
